import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMaxHeight,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";
import zIndexTypes from "../../../theme/zIndexTypes";

interface IDropdownTriggerProps {
  showFlashMessage: boolean;
}

export const DropdownTrigger = styled.div`
  cursor: pointer;
  position: fixed;
  right: 20px;
  top: 68px;
  z-index: ${(props: IDropdownTriggerProps) =>
    props.showFlashMessage ? "1" : `${zIndexTypes.actionBarItem}`};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s ease-in-out;

  &:after {
    transition: 0.25s ease-in-out;
    content: "\f142";
    font-family: FontAwesome;
    font-size: 1.8em;
    color: #fff;
  }

  &:hover,
  &:focus {
    color: #79D9D9;

    &:after {
      color: #79D9D9;
    }
  }

  ${mediaMaxWidth.tablet} {
    right: 10px;
    top: 72px;
    width: 32px;
    height: 32px;

    &:after {
      font-size: 1.6em;
    }
  }
`;

export const DropdownWrapper = styled.div`
  position: absolute;
  border: 1px solid #bdbdbd;
  top: 52px;
  right: 0;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 3px #dcdcdc;

  &::after,
  &::before {
    bottom: 100%;
    right: 12px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: #ffffff;
    border-width: 6px;
    margin-right: 0px;
  }
  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-bottom-color: #bdbdbd;
    border-width: 8px;
    margin-right: -2px;
  }

  ${mediaMaxWidth.tablet} {
    top: 47px;
    right: -4px;
  }
`;

export const DropdownList = styled.div`
  padding: 5px;
`;

export const DropdownListItem = styled.div`
  width: 200px;
  color: #333;
  border-radius: 4px;
  padding: 3px 0 3px 10px;
  font-weight: 500;
  font-size: 0.95em;
  transition: 0.1s ease-in-out;

  &:hover {
    background-color: #79D9D9;
    color: #fff;
  }

  ${mediaMaxWidth.tablet} {
    font-size: 0.9em;
  }
`;

export const ModalBackdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMaxHeight.phone} {
    align-items: unset;
  }

  ${mediaMaxWidth.tablet} {
    align-items: unset;
  }
`;

export const EditModalWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 800px;
  height: 450px;
  z-index: 5;
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;
  overflow: hidden;

  ${mediaMaxWidth.smallDesktop} {
    margin-left: unset;
    width: calc(100vw - 30px);
  }

  ${mediaMaxWidth.tablet} {
    top: 10px;
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
    padding: 10px 10px;
  }

  ${mediaMaxHeight.phone} {
    top: 10px;
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMinWidth.smallDesktop} {
    width: 95%;
  }
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 385px;
  margin: 0 auto;
  padding: 10px 0;
  position: relative;

  ${mediaMaxWidth.tablet} {
    width: 400px;
  }

  ${mediaMaxWidth.phone} {
    width: 85vw;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;

  button {
    margin: 5px 10px;
  }
`;

export const Field = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  margin-bottom: 75px;
`;

export const Label = styled.div`
  color: #333;
  font-size: 0.9em;

  span {
    font-weight: 700;
  }
`;

export const TextInput = styled.textarea`
  display: flex;
  border: 2px solid #e7e7e7;
  border-radius: 4px;
  width: 100%;
  resize: none;
  padding: 10px;
  position: relative;
  margin: 0;
  color: #333;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const CompaniesList = styled.ul`
  color: #333;
  font-size: 0.9em;
  font-weight: 700;
  margin: 10px 0 20px 0;
  padding: 0 20px;
  max-height: 150px;
  overflow: scroll;
`;

export const Company = styled.li``;

export const Error = styled.div`
  position: absolute;
  bottom: -25px;
  font-size: 0.75em;
  width: 100%;
  text-align: center;
  color: #79D9D9;
  font-weight: 600;
`;
